import { Stack } from '@mantine/core';
import { Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { NoContentPlaceholder } from '@/core/components';

import { HierarchyDisciplineSelect } from '@feature/utils';
import { useDisciplineAdminHierarchy } from '@feature/utils/components/hooks/hierarchy/useHierarchy';

export function DisciplineAdminResearchPerfEvalHeader() {
  const { userId, selectProps } = useDisciplineAdminHierarchy();
  const { t } = useTranslation();

  return (
    <Stack>
      <HierarchyDisciplineSelect {...selectProps} />
      {userId == null && <NoContentPlaceholder title={t('hierarchySelectValidation.fromDisciplines')} />}
      {userId != null && <Outlet />}
    </Stack>
  );
}
